export enum OnboardingChapter {
  Introduction = 'Introduction',
  Demographics = 'Demographics',
  Assessment = 'Assessment',
  // Mandatory only when the user's org has the One-on-One Coach enabled; sits between Assessment and GameIntroduction.
  AiCoachGoals = 'AiCoachGoals',
  GameIntroduction = 'GameIntroduction',
  Tutorial = 'Tutorial'
}
